import React from "react";
import Button from "../../../../components/Button.jsx";
import overlayAnim from "../../../../css/components/overlaymodal-animations.module.css";
import styles from "../css/clinic-services.module.css";

export default function ConfirmDeleteModal({ open, onClose, onConfirm, serviceName }) {
  if (!open) return null;

  return (
    <div
      className={`${overlayAnim.modalOverlay} ${open ? overlayAnim.show : overlayAnim.hide}`}
      onClick={onClose}
    >
      <div
        className={`${overlayAnim.modalContent} ${styles.confirmModal}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button className={overlayAnim.closeButton} onClick={onClose}>
          ×
        </button>
        <div className={styles.confirmHeader}>
          <div className={styles.warningIcon}>⚠</div>
          <h2>Delete Service</h2>
          <p>Are you sure you want to delete this service?</p>
          {serviceName && (
            <p className={styles.serviceName}>
              <strong>{serviceName}</strong>
            </p>
          )}
          <p className={styles.warningText}>
            This action cannot be undone. All appointments and consultations linked to this service will be affected.
          </p>
        </div>

        <div className={styles.confirmFooter}>
          <Button variant="primary" onClick={onClose}>
            Cancel
          </Button>
          <Button 
            className={styles.deleteConfirmBtn} 
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            Delete Service
          </Button>
        </div>
      </div>
    </div>
  );
}
